// extracted by mini-css-extract-plugin
export default {"sortIcon":"SortIcon_sortIcon__+WRjS"};